const initialState = {
  loading: false,
  movie: [],
  error: "",
};

const movieReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case "MOVIE_FETCH_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "MOVIE_FETCH_SUCCESS":
      return {
        loading: false,
        movie: payload,
      };

    case "MOVIE_FETCH_FAILURE":
      return {
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default movieReducer;
